import { Routes, useRouter } from '@moonpig/web-core-routing'
import { buildProductDetailsURL } from './buildProductDetailsURL'
import type { ProductInfoProduct, Variant } from '../../types'

const stripTrailingPostcardSuffixFromProductId = (id: string) =>
  id.replace(/-p$/i, '')

export const buildPostcardUpgradeHref = ({
  router,
  product,
  variant,
  storeId,
}: {
  router: ReturnType<typeof useRouter>
  product: ProductInfoProduct
  variant: Variant
  storeId: string
}): string | null => {
  const route = router.getCurrentRoute()

  if (route.name === 'product-details') {
    const params = route.params as Routes['product-details']
    const nextId = stripTrailingPostcardSuffixFromProductId(params.id as string)
    if (nextId === params.id) {
      return null
    }
    const { as } = router.build('product-details', {
      ...params,
      id: nextId,
    })
    return as
  }

  const nextProductId = stripTrailingPostcardSuffixFromProductId(product.id)
  if (nextProductId === product.id) {
    return null
  }

  const groupCardProject =
    router.getCurrentRoute<'search'>()?.params?.groupCardProject

  return buildProductDetailsURL({
    region: storeId,
    categorySlug: product.category.slug,
    slug: product.slug,
    productId: nextProductId,
    size: variant.key,
    groupCardProject,
  })
}
